export default "__VITE_ASSET__43a56698__"